import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { owner as ownerApi } from "./owner-api";

const OwnerAuthContext = createContext(null);

export const OwnerAuthProvider = ({ children }) => {
  const [owner, setOwner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cs_owner_token");
    if (token) {
      ownerApi.me()
        .then(setOwner)
        .catch(() => {
          localStorage.removeItem("cs_owner_token");
          setOwner(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { token, owner: o } = await ownerApi.login(email, password);
    localStorage.setItem("cs_owner_token", token);
    setOwner(o);
    return o;
  };

  const logout = () => {
    localStorage.removeItem("cs_owner_token");
    setOwner(null);
  };

  return (
    <OwnerAuthContext.Provider value={useMemo(
      () => ({ owner, loading, login, logout }),
      [owner, loading],
    )}>
      {children}
    </OwnerAuthContext.Provider>
  );
};

export const useOwnerAuth = () => useContext(OwnerAuthContext);
